export const generateCacheBusterParamString = () => {
  const param = new URLSearchParams();
  param.append('cacheBuster', new Date().getTime().toString());
  return param.toString();
};
